import { Controller } from "@hotwired/stimulus"

// Reads the chosen package's size before the browser sends it.
// Nginx rejects an oversized body with 413 and the app never sees
// the file, so the warning has to happen here.
export default class extends Controller {
  static targets = ["input", "warning"]
  static values = { maxBytes: Number }

  check() {
    const file = this.inputTarget.files[0]
    const over = file && file.size > this.maxBytesValue
    this.inputTarget.setCustomValidity(over ? this.warningTarget.textContent.trim() : "")
    this.warningTarget.classList.toggle("d-none", !over)
    if (over) this.inputTarget.reportValidity()
  }
}
